<template>
  <v-sheet :dark="dark" class="fill-height" :color="!dark ? 'background' : null">
    <page-header
      :banner-height="250"
      :banner="banner"
      back="dashboard"
      :dark="dark"
      title="Aanmelden"
    >
    </page-header>
    <v-card
     tile
      class="mx-auto pb-15"
      flat
      color="transparent"
    >
  
    
    </v-card>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../components/PageHeader.vue";

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      loading: true,
     
    };
  },
  computed: {
    ...mapGetters(["dark"]),
    banner(){
        return this.$config.page.banner
    }
  },
  mounted() {
    
  },
  watch: {
    
  },
  methods: {
    ...mapActions(["setHost"]),
    async load(search) {
      
    },
  
  },
};
</script>

